import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './blocks/ModernBlocks.css';

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const postsPerPage = 9;

  // Sample blog data
  const blogData = [
    {
      id: 1,
      title: "The Future of Web Development: AI-Powered Tools",
      excerpt: "Discover how artificial intelligence is revolutionizing web development workflows and what it means for developers and businesses.",
      content: "Artificial intelligence is transforming every industry, and web development is no exception. From automated code generation to intelligent debugging tools, AI is making development faster, more efficient, and more accessible than ever before...",
      author: "Sarah Johnson",
      authorAvatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
      date: "2024-01-15",
      category: "Technology",
      tags: ["AI", "Web Development", "Future Tech"],
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=400&fit=crop",
      featured: true
    },
    {
      id: 2,
      title: "Building Scalable Microservices Architecture",
      excerpt: "Learn the best practices for designing and implementing microservices that can scale with your business growth.",
      content: "Microservices architecture has become the go-to solution for building scalable, maintainable applications. But implementing it correctly requires careful planning and understanding of key principles...",
      author: "Michael Chen",
      authorAvatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      date: "2024-01-12",
      category: "Architecture",
      tags: ["Microservices", "Scalability", "Backend"],
      readTime: "8 min read",
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&h=400&fit=crop"
    },
    {
      id: 3,
      title: "React Performance Optimization Techniques",
      excerpt: "Master the art of optimizing React applications for better performance and user experience.",
      content: "React is powerful, but without proper optimization, your applications can become slow and unresponsive. Here are proven techniques to boost your React app's performance...",
      author: "Emily Rodriguez",
      authorAvatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      date: "2024-01-10",
      category: "Frontend",
      tags: ["React", "Performance", "JavaScript"],
      readTime: "6 min read",
      image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=600&h=400&fit=crop"
    },
    {
      id: 4,
      title: "DevOps Best Practices for Modern Teams",
      excerpt: "Streamline your development workflow with these essential DevOps practices and tools.",
      content: "DevOps is more than just a buzzword—it's a culture that bridges the gap between development and operations. Here's how to implement it effectively...",
      author: "David Kim",
      authorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      date: "2024-01-08",
      category: "DevOps",
      tags: ["DevOps", "CI/CD", "Automation"],
      readTime: "7 min read",
      image: "https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=600&h=400&fit=crop"
    },
    {
      id: 5,
      title: "UI/UX Design Trends for 2024",
      excerpt: "Stay ahead of the curve with the latest design trends that will dominate digital experiences this year.",
      content: "Design trends evolve rapidly, and staying current is crucial for creating engaging user experiences. Here are the trends that will shape 2024...",
      author: "Lisa Wang",
      authorAvatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
      date: "2024-01-05",
      category: "Design",
      tags: ["UI/UX", "Design Trends", "User Experience"],
      readTime: "4 min read",
      image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=600&h=400&fit=crop"
    },
    {
      id: 6,
      title: "Cloud-Native Application Development",
      excerpt: "Build applications designed for the cloud from the ground up with these essential principles.",
      content: "Cloud-native development is not just about deploying to the cloud—it's about building applications that leverage cloud capabilities fully...",
      author: "Alex Thompson",
      authorAvatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
      date: "2024-01-03",
      category: "Cloud",
      tags: ["Cloud", "Kubernetes", "Docker"],
      readTime: "9 min read",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=400&fit=crop"
    },
    {
      id: 7,
      title: "Mobile App Development: Native vs Cross-Platform",
      excerpt: "Compare native and cross-platform development approaches to choose the right strategy for your mobile app.",
      content: "Choosing between native and cross-platform development is one of the most important decisions in mobile app development. Here's what you need to know...",
      author: "Maria Garcia",
      authorAvatar: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop&crop=face",
      date: "2024-01-01",
      category: "Mobile",
      tags: ["Mobile", "React Native", "Flutter"],
      readTime: "6 min read",
      image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&h=400&fit=crop"
    },
    {
      id: 8,
      title: "Cybersecurity Best Practices for Web Applications",
      excerpt: "Protect your web applications from common security vulnerabilities with these essential practices.",
      content: "Security should be a top priority in web development. Here are the most important practices to keep your applications secure...",
      author: "James Wilson",
      authorAvatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face",
      date: "2023-12-28",
      category: "Security",
      tags: ["Security", "OWASP", "Best Practices"],
      readTime: "8 min read",
      image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=600&h=400&fit=crop"
    },
    {
      id: 9,
      title: "Database Design Patterns for Scalable Applications",
      excerpt: "Learn proven database design patterns that will help your applications scale efficiently.",
      content: "Good database design is crucial for application performance and scalability. Here are the patterns that successful applications use...",
      author: "Rachel Green",
      authorAvatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
      date: "2023-12-25",
      category: "Database",
      tags: ["Database", "SQL", "NoSQL"],
      readTime: "7 min read",
      image: "https://images.unsplash.com/photo-1544383835-bda2bc66a55d?w=600&h=400&fit=crop"
    }
  ];

  const categories = ['all', 'Technology', 'Architecture', 'Frontend', 'DevOps', 'Design', 'Cloud', 'Mobile', 'Security', 'Database'];

  useEffect(() => {
    // Simulate loading
    setTimeout(() => {
      setPosts(blogData);
      setFilteredPosts(blogData);
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    let filtered = posts;

    // Filter by category
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(post => post.category === selectedCategory);
    }

    // Filter by search term
    if (searchTerm) {
      filtered = filtered.filter(post =>
        post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        post.excerpt.toLowerCase().includes(searchTerm.toLowerCase()) ||
        post.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }

    setFilteredPosts(filtered);
    setCurrentPage(1);
  }, [posts, selectedCategory, searchTerm]);

  // Get current posts for pagination
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  if (loading) {
    return (
      <div className="blog-loading">
        <div className="loading-spinner"></div>
        <p>Loading blog posts...</p>
      </div>
    );
  }

  return (
    <div className="blog-page">
      {/* Hero Section */}
      <div className="blog-hero">
        <div className="blog-hero-container">
          <h1 className="blog-hero-title">Our Blog</h1>
          <p className="blog-hero-subtitle">
            Insights, tutorials, and thoughts on software development, design, and technology
          </p>
        </div>
      </div>

      {/* Filters and Search */}
      <div className="blog-filters">
        <div className="blog-filters-container">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search articles..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>

          <div className="category-filters">
            {categories.map(category => (
              <button
                key={category}
                className={`category-filter ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category === 'all' ? 'All Posts' : category}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Blog Posts Grid */}
      <div className="blog-main">
        <div className="blog-container">
          {currentPosts.length === 0 ? (
            <div className="no-posts">
              <h3>No posts found</h3>
              <p>Try adjusting your search or filter criteria.</p>
            </div>
          ) : (
            <div className="blog-grid">
              {currentPosts.map((post, index) => (
                <article key={post.id} className={`blog-card ${post.featured ? 'featured' : ''}`}>
                  <div className="blog-card-image">
                    <img src={post.image} alt={post.title} />
                    {post.featured && <span className="featured-badge">Featured</span>}
                  </div>
                  
                  <div className="blog-card-content">
                    <div className="blog-card-meta">
                      <span className="blog-category">{post.category}</span>
                      <span className="blog-date">{formatDate(post.date)}</span>
                    </div>
                    
                    <h2 className="blog-card-title">
                      <Link to={`/blog/${post.id}`}>{post.title}</Link>
                    </h2>
                    
                    <p className="blog-card-excerpt">{post.excerpt}</p>
                    
                    <div className="blog-card-tags">
                      {post.tags.slice(0, 3).map(tag => (
                        <span key={tag} className="blog-tag">{tag}</span>
                      ))}
                    </div>
                    
                    <div className="blog-card-footer">
                      <div className="blog-author">
                        <img src={post.authorAvatar} alt={post.author} className="author-avatar" />
                        <span className="author-name">{post.author}</span>
                      </div>
                      <span className="read-time">{post.readTime}</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          )}

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="blog-pagination">
              <button
                className="pagination-button"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Previous
              </button>
              
              <div className="pagination-numbers">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => (
                  <button
                    key={number}
                    className={`pagination-number ${currentPage === number ? 'active' : ''}`}
                    onClick={() => setCurrentPage(number)}
                  >
                    {number}
                  </button>
                ))}
              </div>
              
              <button
                className="pagination-button"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogList; 